'use client'

import {useEffect} from 'react'

export function PublicEmbedResizeBridge() {
    useEffect(() => {
        const root = document.querySelector<HTMLElement>('[data-public-embed-root]')
        if (!root) return

        const postHeight = () => {
            window.parent?.postMessage({
                type: 'fitro.publicEmbed.resize',
                version: 1,
                height: root.scrollHeight,
            }, '*')
        }

        postHeight()
        const observer = new ResizeObserver(postHeight)
        observer.observe(root)
        window.addEventListener('load', postHeight)

        return () => {
            observer.disconnect()
            window.removeEventListener('load', postHeight)
        }
    }, [])

    return null
}
